import type { MinimalRawBlock } from "@/types/page-block";

/**
 * Resolves a unique identifier for a content block.
 * Priority: _id → internalName → __typename → fallback
 */
export function getBlockId(
  item: MinimalRawBlock | null,
  index: number
): string {
  if (!item) {
    return `content-block-${index}`;
  }

  let prefix = "content-block";

  if (item.id) {
    prefix = item.id;
  }

  if (item.sys?.id) {
    prefix = item.sys.id;
  }

  if (item.__typename) {
    prefix = item.__typename;
  }

  return `${prefix}-${index}`;
}
